(function () {
  function qs(el, sel)  { return el.querySelector(sel); }
  function qsa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }

  // === NEW: scroll-lock helpers (no other changes) ===
  var __rsScrollY = 0;
  function rsLockScroll(){
    if (document.body.classList.contains('rs-lock')) return;
    __rsScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${__rsScrollY}px`;
    document.body.classList.add('rs-lock');
  }
  function rsUnlockScroll(){
    if (!document.body.classList.contains('rs-lock')) return;
    document.body.classList.remove('rs-lock');
    document.body.style.top = '';
    window.scrollTo(0, __rsScrollY);
  }
  // ===================================================

  // Matches: <!--page-->, &lt;!--page--&gt;, [[page]], <hr class="rs-page"> (bare or wrapped)
  // CHANGE #1: broader marker matcher (keeps everything else the same)
var SPLIT_RE = new RegExp([
  '<!--\\s*page\\s*-->',                              // <!--page-->
  '&lt;!--\\s*page\\s*--&gt;',                        // encoded
  '\\[\\[\\s*page\\s*\\]\\]',                         // [[page]]
  '<p[^>]*>\\s*<!--\\s*page\\s*-->\\s*</p>',          // wrapped comment
  '<p[^>]*>\\s*&lt;!--\\s*page\\s*--&gt;\\s*</p>',    // wrapped encoded
  '<p[^>]*>\\s*\\[\\[\\s*page\\s*\\]\\]\\s*</p>',     // wrapped [[page]]
  '<p[^>]*>\\s*<hr[^>]*\\brs-page\\b[^>]*>\\s*</p>',  // wrapped hr
  '<hr[^>]*\\brs-page\\b[^>]*>'                       // bare hr
].join('|'), 'gi');

// CHANGE #2: trim junk around pages to remove big white gaps
function cleanPart(html){
  if(!html) return '';
  html = html.replace(/^(?:\s*<br\s*\/?>\s*)+/i, ''); // leading <br>
  html = html.replace(/(?:\s*<br\s*\/?>\s*)+$/i, ''); // trailing <br>
  html = html.replace(/<p[^>]*>\s*(?:&nbsp;|\u00a0|\s|<br\s*\/?>)*<\/p>/gi, ''); // empty <p>
  return html.trim();
}


  function initOne(root) {
    if (root.__rsReady) return; root.__rsReady = true;

    var btn     = qs(root, '.read-sample__btn');
    var modal   = qs(root, '.read-sample__modal');
    var dialog  = qs(root, '.read-sample__dialog');
    var close   = qs(root, '.read-sample__close');
    var cont    = qs(root, '.read-sample__content');
    var prevB   = qs(root, '.nav.prev');
    var nextB   = qs(root, '.nav.next');
    var pageEl  = qs(root, '.read-sample__progress .page b');
    var pagesEl = qs(root, '.read-sample__progress .pages b');
    var fill    = qs(root, '.read-sample__progress .fill');

    if (!btn || !modal || !dialog || !cont) return;

    // Build pages
    var customDelim = cont.getAttribute('data-delim');     // keep your override if set
var raw = (cont.innerHTML || '').trim()
  .replace(/&lt;/g,'<').replace(/&gt;/g,'>');

var parts = (customDelim && raw.indexOf(customDelim) > -1)
  ? raw.split(customDelim).map(cleanPart).filter(Boolean)
  : raw.split(SPLIT_RE).map(cleanPart).filter(Boolean);


    if (!parts.length) { root.style.display = 'none'; return; }

    var idx = 0, total = parts.length;

    function render() {
      cont.innerHTML = parts[idx];
      if (pageEl)  pageEl.textContent  = (idx + 1);
      if (pagesEl) pagesEl.textContent = total;
      if (prevB) prevB.disabled = (idx === 0);
      if (nextB) nextB.disabled = (idx >= total - 1);
      if (fill)  fill.style.width = (total > 1 ? ((idx + 1) / total) * 100 : 100) + '%';
      cont.scrollTop = 0;
    }

    function hide() {
      modal.hidden = true;
      btn.setAttribute('aria-expanded','false');
      // CHANGED: use scroll unlock
      rsUnlockScroll();
      btn.focus && btn.focus();
    }

    function open() {
      modal.hidden = false;
      btn.setAttribute('aria-expanded','true');
      render();
      if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex','-1');
      dialog.focus({ preventScroll:true });
      // CHANGED: use scroll lock
      rsLockScroll();
    }

    // Core listeners
    btn.addEventListener('click', open);
    close && close.addEventListener('click', hide);
    modal.addEventListener('click', function(e){ if (e.target === modal) hide(); });
    document.addEventListener('keydown', function(e){
      if (!modal.hidden && (e.key === 'Escape' || e.key === 'Esc')) hide();
      if (!modal.hidden && (e.key === 'ArrowRight' || e.key === 'PageDown')) { if (idx < total-1){ idx++; render(); } }
      if (!modal.hidden && (e.key === 'ArrowLeft'  || e.key === 'PageUp'))   { if (idx > 0)      { idx--; render(); } }
    });
    prevB && prevB.addEventListener('click', function(){ if (idx > 0)      { idx--; render(); } });
    nextB && nextB.addEventListener('click', function(){ if (idx < total-1){ idx++; render(); } });

    // ---------- CTA handlers (unchanged) ----------
    dialog.addEventListener('click', async function(e){
      if (e.target && e.target.classList.contains('rs-choose-format')) {
        var targetId = e.target.getAttribute('data-target') || 'read-sip';
        hide();
        requestAnimationFrame(function(){
          var el = document.getElementById(targetId);
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return;
      }
      if (e.target && e.target.classList.contains('rs-make-bundle')) {
        var targetId2 = e.target.getAttribute('data-target') || 'read-sip';
        hide();
        requestAnimationFrame(function(){
          var el2 = document.getElementById(targetId2);
          if (el2) el2.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return;
      }

      if (e.target && e.target.classList.contains('rs-add-selected')) {
        try {
          var idInput = document.querySelector('form[action="/cart/add"] [name="id"]');
          var vid = idInput && idInput.value;
          if (!vid) throw new Error('No variant id found');

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(vid), quantity: 1 })
          });

          hide();
          var openerSel = e.target.getAttribute('data-cart-toggle') || '';
          var opener = openerSel ? document.querySelector(openerSel) : null;
          if (opener) opener.click(); else window.location.assign('/cart');
        } catch (err) {
          console.error('Quick add selected failed', err);
          window.location.assign('/cart');
        }
        return;
      }

      if (e.target && e.target.classList.contains('rs-switch-paperback')) {
        var optName  = (e.target.getAttribute('data-option-name') || 'Format').toLowerCase();
        var pbValue  = (e.target.getAttribute('data-paperback')   || 'Paperback').toLowerCase();

        try {
          var secId  = root.getAttribute('data-section');
          var prodEl = document.getElementById('ProductJson-' + secId);
          var data   = prodEl ? JSON.parse(prodEl.textContent) : null;

          var optionIndex = -1;
          if (data && Array.isArray(data.options)) {
            optionIndex = data.options.findIndex(function(o){ return (o || '').toLowerCase() === optName; });
          }

          var targetVariant = null;
          if (data && Array.isArray(data.variants) && optionIndex >= 0) {
            targetVariant = data.variants.find(function(v){
              var val = ((v.options || [])[optionIndex] || '').toLowerCase();
              return val === pbValue && v.available;
            }) || data.variants.find(function(v){
              var val = ((v.options || [])[optionIndex] || '').toLowerCase();
              return val === pbValue;
            });
          }

          hide();
          if (targetVariant && targetVariant.id) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', targetVariant.id);
            window.location.assign(url.toString());
          } else {
            var anchor = document.getElementById('read-sip');
            if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        } catch (e2) {
          console.error('Switch to Paperback failed', e2);
        }
        return;
      }

      if (e.target && e.target.classList.contains('rs-jump')) {
        var tid = e.target.getAttribute('data-target') || 'read-sip';
        hide();
        requestAnimationFrame(function(){
          var el3 = document.getElementById(tid);
          if (el3) el3.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return;
      }
    });
    // ---------- end CTA handlers ----------
  }

  function boot() { qsa(document, '.read-sample').forEach(initOne); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();


